<template>
  <div class="sm:flex text-center sm:text-left justify-between text-xs" :key="version">
    <div class="text-gray-500 mb-1 sm:mb-0">
      <span class="flex items-center">
        <!-- <SpeakerphoneIcon class="w-4 h-4 inline mr-1" /> -->
        <span v-if="$root.hasRole('manager')">
          <Link href="/changelog/" class="link">{{ version }}</Link> - © Archibien
          {{ new Date().getFullYear() }}, tous droits réservés.
        </span>
        <span v-else
          >{{ version }} - © Archibien {{ new Date().getFullYear() }}, tous droits réservés.</span
        >
      </span>
    </div>
    <div class="space-x-2">
      <a target="_blank" class="link" href="https://archibien.com/mentions-legales/">
        Mentions légales</a
      >
      <Link v-if="$root.hasAnyRole(['agency', 'pro'])" href="/account/#cgv" class="link"
        >CGU et CGV</Link
      >
      <a v-else target="_blank" class="link" href="https://archibien.com/cgu/">CGU et CGV</a>
      <a target="_blank" class="link" href="https://archibien.com/cookies/"
        >Politique concernant les cookies</a
      >
    </div>
  </div>
</template>

<script setup lang="ts">
import version from '@/api/version'
</script>
